import { sessionViewSchema, type Permission, type SessionView } from '@wodi/shared';
import { queryOptions } from '@tanstack/react-query';

import { api, ApiError } from './client.ts';

/** The signed-in session, or null when there is none. */
export const sessionQuery = queryOptions({
  queryKey: ['session'],
  queryFn: async (): Promise<SessionView | null> => {
    try {
      return await api('GET', '/auth/session', { schema: sessionViewSchema });
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) return null;
      throw error;
    }
  },
  staleTime: 30_000,
});

export function can(session: SessionView, permission: Permission): boolean {
  return (session.permissions as readonly string[]).includes(permission);
}

/** Only same-site paths, so a crafted link can't send someone elsewhere after sign-in. */
export function safeNext(next: string | undefined): string {
  if (
    next === undefined ||
    !next.startsWith('/') ||
    next.startsWith('//') ||
    next.startsWith('/sign-in')
  )
    return '/';
  return next;
}
